/**
 * Shared formatting utilities.
 *
 * Single source of truth for value and time formatting across the frontend.
 */

/**
 * Format a numeric value using B/M/K notation.
 * @param {number} val - The value to format
 * @param {boolean} showSign - Whether to show +/- prefix (default: true)
 * @returns {string} Formatted string
 */
export function formatValue(val, showSign = true) {
  if (val == null || isNaN(val)) return '-';
  const sign = showSign ? (val >= 0 ? '+' : '') : (val < 0 ? '' : '');
  const absVal = Math.abs(val);
  if (absVal >= 1e12) return `${sign}${(val / 1e12).toFixed(1)}T`;
  if (absVal >= 1e9) return `${sign}${(val / 1e9).toFixed(1)}B`;
  if (absVal >= 1e6) return `${sign}${(val / 1e6).toFixed(1)}M`;
  if (absVal >= 1e3) return `${sign}${(val / 1e3).toFixed(1)}K`;
  return `${sign}${val.toFixed(0)}`;
}

/**
 * Format a Unix timestamp to time string with timezone support.
 * @param {number} timestamp - Unix timestamp in seconds
 * @param {string} timezone - 'ET' or 'UTC'
 * @returns {string} Formatted time string (HH:MM)
 */
export function formatTime(timestamp, timezone = 'ET') {
  try {
    const date = new Date(timestamp * 1000);
    const timeZone = timezone === 'ET' ? 'America/New_York' : 'UTC';
    return date.toLocaleString('en-US', {
      timeZone,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } catch (e) {
    return '';
  }
}
